import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';

const useStyles = makeStyles((theme: any) => ({
  card: {
    height: '100%',
    color: theme.palette.brand.greenDark,
    '&:hover': {
      border: `1px solid ${theme.palette.brand.blueSky}`,
    },
  },
  active: {
    border: `1px solid ${theme.palette.brand.blueSky}`,
    backgroundColor: theme.palette.primary.light,
  },
  cardActionArea: {
    height: '100%',
    '&:hover': { backgroundColor: theme.palette.primary.light },
    '& .MuiCardActionArea-focusHighlight': { backgroundColor: 'inherit' },
    '& .Mui-focusVisible': { backgroundColor: 'inherit' },
    '& .MuiCardActionArea-root': { backgroundColor: 'inherit' },
  },
}));

export default function ChooseBankOptionCard({
  id,
  isActive,
  children,
  onClick,
  disabled,
}: {
  id: string;
  isActive: boolean;
  children: JSX.Element;
  onClick: any;
  disabled: boolean;
}) {
  const classes = useStyles();

  return (
    <Card className={`${classes.card} ${isActive ? classes.active : ''}`}>
      <CardActionArea
        disabled={disabled}
        className={classes.cardActionArea}
        onClick={() => onClick(id)}
      >
        {children}
      </CardActionArea>
    </Card>
  );
}
